import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../App";
import { IMAGES } from "../images";
import Reveal from "./Reveal";

export default function ImageBreak() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} data-testid="emotional-section" className="relative h-[70vh] overflow-hidden md:h-[88vh]">
      <motion.img
        src={IMAGES.emotional}
        alt={t.emotional.alt}
        style={{ y }}
        className="absolute inset-0 h-full w-full scale-[1.18] object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ink/45" />
      <div className="relative z-10 flex h-full flex-col justify-end px-6 pb-16 md:px-12 md:pb-20 lg:px-20">
        <Reveal>
          <h2 className="max-w-3xl font-serif text-3xl font-medium uppercase leading-snug tracking-wide text-ivory sm:text-4xl lg:text-5xl">
            {t.emotional.headline}
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-ivory/70 md:text-base">
            {t.emotional.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
